import {
  Card, CardContent, CardHeader, Divider, ExpansionPanelDetails, ExpansionPanelSummary, FormControlLabel, FormGroup,
  Grid, Typography, Switch, TextField, Button, Dialog, DialogContent, IconButton, DialogActions, DialogTitle, Container,
  CircularProgress, Snackbar, Checkbox, CardActions, Tooltip, Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Backdrop } from '@material-ui/core/';
import React, { useEffect } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ExpansionPanel } from '@material-ui/core'
import SaveIcon from '@material-ui/icons/Save';
import InfoIcon from '@material-ui/icons/Info';
import { getUser } from 'src/utils/Common';
import Alert from '@material-ui/lab/Alert';
import axios from 'src/utils/axios';
import CloseIcon from '@mui/icons-material/Close';
import SmsTextGuide from '../SmsManagement/SmsTextGuide';
import { Autocomplete } from '@mui/material';
import { confirmAlert } from 'react-confirm-alert';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  title: {
    width: '100%',
    textAlign: 'center',
  },
  header: {
    fontWeight: 'bold',
    fontSize: '15px',
    width: '100%',
    textAlign: 'center',
    color: 'red'
  },
  cards: {
    minHeight: 500
  },
  button: {
    marginLeft: theme.spacing(2),
  },
  backdrop: {
    zIndex: 2000,
    color: '#fff'
  },
  activeCard: {
    backgroundColor: '	#bebebe', /* Aktif kart arka plan rengi */
    minHeight: 500
  },
  inactiveCard: {
    backgroundColor: '#ffffff', /* Pasif kart arka plan rengi */
    minHeight: 500
  },
}));


function SmsManagement() {
  const classes = useStyles();
  const SessionUser = getUser();

  const [expandedAutomaticSms, setExpandedAutomaticSms] = React.useState(true);
  const [smsInfoPopUp, setSmsInfoPopUp] = React.useState(false)
  const [smsSablonOnizle, setSmsSablonOnizle] = React.useState(false)
  const [smsSablonGoruntule, setSmsSablonGoruntule] = React.useState(false)
  const [smsGoruntulemeData, setSmsGoruntulemeData] = React.useState([])
  const [smsGoruntulemeData2, setSmsGoruntulemeData2] = React.useState([])
  const [brandSessionUserData, setBrandSessionUserData] = React.useState([]);
  const [sablonOnizlemeMetin, setSablonOnizlemeMetin] = React.useState([]);
  const [genelSmsBilgisi, setGenelSmsBilgisi] = React.useState([]);
  const [genelSmsSablonBilgisiRequest, setGenelSmsBilgisiRequest] = React.useState([]);
  const [sablonDurumBilgisiRequest, setSablonDurumBilgisiRequest] = React.useState([]);
  const [sablonUrunGrupBilgisiRequest, setSablonUrunGrupBilgisiRequest] = React.useState([]);
  const [loadingx, setLoadingx] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [smsModeller, setSmsModeller] = React.useState([]);
  const [smsDurumlar, setSmsDurumlar] = React.useState([]);
  const [sablonDurumBilgisi, setSablonDurumBilgisi] = React.useState([]);
  const [sablonUrunGrupBilgisi, setSablonUrunGrupBilgisi] = React.useState([]);
  const [smsAdet, setSmsAdet] = React.useState(0);
  const [durumVeUrunGruplariPopUp, setDurumVeUrunGruplariPopUp] = React.useState(false)
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = React.useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const [excludeIds, setExcludeIds] = React.useState([]);

  useEffect(() => {
    GetGeneralSmsInfo();
    getSmsDurumlar();
    getSmsModeller();
    GetGeneralUnportableSmsInfo();
  }, []);

  useEffect(() => {
    setLoading(true)
    if (genelSmsBilgisi !== null) {
      setGenelSmsBilgisiRequest(genelSmsBilgisi);
      setLoading(false)
    }
    if (sablonDurumBilgisi !== null) {
      setSablonDurumBilgisiRequest(sablonDurumBilgisi);
      setLoading(false)
    }
    if (sablonUrunGrupBilgisi !== null) {
      setSablonUrunGrupBilgisiRequest(sablonUrunGrupBilgisi);
      setLoading(false)
    }
  }, [genelSmsBilgisi, sablonDurumBilgisi, sablonUrunGrupBilgisi]);


  const GetGeneralSmsInfo = () => {
    setLoadingx(true);
    axios.get("/GetGenelSmsBilgiler").then((response) => {
      setGenelSmsBilgisi(response.data);
      setSmsAdet(response.data.length);
      setLoadingx(false);
    })
  }

  const GetGeneralUnportableSmsInfo = () => {
    setLoadingx(true);
    axios.get("/GetGenelTasinamayanSmsBilgiler")
      .then((response) => {
        setExcludeIds(response.data.map(item => item.MESAJ_SABLON_ID));
        setLoadingx(false);
      });
  }


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleChangeCheckbox = (event, id) => {
    var CheckControl = 0;
    if (event.target.checked) {
      CheckControl = 1;
    } else {
      CheckControl = 0;
    }
    var Data = [...genelSmsSablonBilgisiRequest];
    var index = Data.findIndex(x => x.ID === id);
    var Item = { ...Data[index], AKTIF: CheckControl }
    Data[index] = Item;
    setGenelSmsBilgisiRequest(Data);
  };

  const handleChangeText = (event, TemplateDetailId) => {
    var Data = [...genelSmsSablonBilgisiRequest];
    var index = Data.findIndex(x => x.ID === TemplateDetailId);
    var Item = { ...Data[index], SMS_METIN: event.target.value };
    Data[index] = Item;
    setGenelSmsBilgisiRequest(Data);
  }

  const addSmsEmailTemplate = (event, TemplateDetailId) => {
    var Data = [...genelSmsSablonBilgisiRequest];
    var index = Data.findIndex(x => x.ID === TemplateDetailId);
    var Item = { ...Data[index] };

    var ExData = [...genelSmsBilgisi];
    var Exindex = ExData.findIndex(x => x.ID === TemplateDetailId);
    var ExItem = { ...ExData[Exindex] };

    if (Item.AKTIF === true) {
      Item = { ...Data[index], AKTIF: 1 };
    }
    if (Item.AKTIF === false) {
      Item = { ...Data[index], AKTIF: 0 };
    }
    if (ExItem.AKTIF === true) {
      ExItem = { ...ExData[Exindex], AKTIF: 1 };
    }
    if (ExItem.AKTIF === false) {
      ExItem = { ...ExData[Exindex], AKTIF: 0 };
    }

    const data = {
      SmsAktif: Item.AKTIF,
      SablonAcıklama: Item.SMS_METIN,
      SablonKullanıcıId: Item.ID,
      SmsBaslik: Item.ACIKLAMA,
      SicilNo: "" //okta
    };
    axios.get(`/GetSmsSablonDurum/` + TemplateDetailId).then((response) => {
      if (response.data.length > 0) {
        setSablonDurumBilgisi(response.data);
      }
      else {
        setSablonDurumBilgisi([]);
      }
    })
    axios.get(`/GetSmsSablonUrunGruplari/` + TemplateDetailId).then((response) => {
      if (response.data.length > 0) {
        setSablonUrunGrupBilgisi(response.data);
      }
      else {
        setSablonUrunGrupBilgisi([]);
      }
    })


    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    //Confirm Alert Yönlendirmesi
    confirmAlert({
      message: ('Şablonun Durumunu ve Ürün Gruplarını Güncellemek İstiyor musunuz?'),
      buttons: [
        {
          label: ('Güncelle'),
          onClick: () => {
            if (ExItem.ACIKLAMA === Item.ACIKLAMA && ExItem.AKTIF === Item.AKTIF && ExItem.SMS_METIN === Item.SMS_METIN) {
              setDurumVeUrunGruplariPopUp(true);
            } else {
              setLoadingx(true)
              axios.post('/SetSmsIcerikGuncelleme', data, config).then(response => {
                setresponseMessage(response.data.ErrorDescription)
                setUyariTip("success");
                setUyari(true);
                setDurumVeUrunGruplariPopUp(true);
                setLoadingx(false);
              });
              setLoadingx(false);
            }

          }
        },
        {
          label: ('Güncellemeden Devam et'),
          onClick: () => {
            axios.post('/SetSmsIcerikGuncelleme', data, config).then(response => {
              setresponseMessage(response.data.ErrorDescription)
              setUyariTip("success");
              setUyari(true);
            });
          }
        }
      ],
    })
  }


  function urunGrubuVeDurumGuncelle() {

    var MarkaCodes = [];
    sablonUrunGrupBilgisiRequest.map((i) => {
      MarkaCodes.push(i.Id);
    })

    var Status = [];
    sablonDurumBilgisiRequest.map((i) => {
      Status.push(i.DURUM_ID);
    })

    var TemplateDetailId = [];
    sablonDurumBilgisiRequest.map((i) => {
      TemplateDetailId.push(i.MESAJ_SABLON_ID);
    })

    const data = {
      TemplateDetailId: TemplateDetailId?.toString(),
      ModelCodes: MarkaCodes?.toString(),
      Status: Status?.toString(),
      SessionUser: "" //Okta 
    }

    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('/SetSmsDurumveModelKoduGuncelleme', data, config).then(response => {
      setresponseMessage(response.data.ErrorDescription)
      setUyariTip("success");
      setUyari(true);
    });


    setDurumVeUrunGruplariPopUp(false);
  }


  const handleChangeHeader = (event, TemplateDetailId) => {
    var Data = [...genelSmsSablonBilgisiRequest];
    var index = Data.findIndex(x => x.ID === TemplateDetailId);
    var Item = { ...Data[index], ACIKLAMA: event.target.value };
    Data[index] = Item;
    setGenelSmsBilgisiRequest(Data);
  }

  const handleChangeStatus = (event, TemplateDetailId, newValue) => {
    var Data = [...sablonDurumBilgisiRequest];
    var index = Data.findIndex(x => x.MESAJ_SABLON_ID === TemplateDetailId);
    var Item = { ...Data[index], DURUM_ID: newValue.DURUM };
    Data[index] = Item;
    setSablonDurumBilgisiRequest(Data);
  }

  const GetBrandSessionUser = (templateId) => {
    setLoading(true);
    axios.get(`/GetMarkaKullaniciAdlar/` + templateId).then((response) => {
      if (response.data.length > 0) {
        setBrandSessionUserData(response.data);
        setSmsInfoPopUp(true);
      }
      setLoading(false);
    })
  }

  const GetSablonOnizleme = (templateId) => {
    setLoading(true);
    axios.get(`/GetSmsSablonOnizle/` + templateId).then((response) => {
      if (response.data.length > 0) {
        setSablonOnizlemeMetin(response.data);
        setSmsSablonOnizle(true);
      } else {
        setresponseMessage('Bu Şablon Altyapıya Uygun Olmadığından Önizleme Gerçekleştirilemez.');
        setUyariTip("error");
        setUyari(true);
      }
      setLoading(false);
    })
  }

  const GetSablonGoruntule = (templateId) => {
    setLoading(true);
    axios.get(`/GetSmsSablonDurum/` + templateId).then((response) => {
      if (response.data.length > 0) {
        setSmsGoruntulemeData(response.data);
        setLoading(false);
      }
      else {
        setSmsGoruntulemeData([]);
      }
    })
    setLoading(true);
    axios.get(`/GetSmsSablonUrunGruplari/` + templateId).then((response) => {
      if (response.data.length > 0) {
        setSmsGoruntulemeData2(response.data);
        setLoading(false);
      }
      else {
        setSmsGoruntulemeData2([]);
      }
    })
    setSmsSablonGoruntule(true);
  }

  const getSmsDurumlar = () => {
    axios.get("/GetSmsDurumlar").then((response) => {
      setSmsDurumlar(response.data);
    })
  }
  const getSmsModeller = () => {
    axios.get("/GetSmsModeller").then((response) => {
      setSmsModeller(response.data);
    })
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={loadingx || loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar sx={{ width: '100%', position: 'center', zIndex: 'top' }} open={uyari} autoHideDuration={6000} onClose={uyariKapat}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={uyariKapat} variant='filled' severity={uyariTip}>
          {responseMessage}
        </Alert>
      </Snackbar>
      <SmsTextGuide />
      <Divider />
      <ExpansionPanel expanded={expandedAutomaticSms} onChange={() => { setExpandedAutomaticSms(!expandedAutomaticSms); }}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header">
          <Typography className={classes.header} variant="h6">
            Toplam {smsAdet} sms bulunmaktadır.
          </Typography>
        </ExpansionPanelSummary>
        <Divider />
        <ExpansionPanelDetails>
          <Grid container spacing={2}>
            {
              genelSmsSablonBilgisiRequest?.map((item) => (

                <Grid item xs={12} sm={4} lg={4} key={item.ID}>
                  <Card>
                    <CardHeader title={(item.ACIKLAMA)} action={
                      <>
                        <Tooltip title="Şablon İçeriğini Önizle">
                          <IconButton size="medium" color="primary" disabled={!excludeIds?.includes(item.ID) ? false : true} onClick={() => { GetSablonOnizleme(item.ID); }}>
                            <RemoveRedEyeIcon style={{ marginTop: '0.5rem' }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Şablon İçeriğini Görüntüle">
                          <IconButton size="medium" color="primary" onClick={() => { GetSablonGoruntule(item.ID); }}>
                            <InfoIcon style={{ marginTop: '0.5rem' }} />
                          </IconButton>
                        </Tooltip>
                      </>
                    } />
                    <Divider />
                    <CardContent>
                      <Grid item xs={12} sm={12} lg={12}>
                        <FormControlLabel
                          style={{ display: 'flex', justifyContent: 'flex-end' }}
                          control={<Switch checked={item.AKTIF}
                            onChange={(event) => handleChangeCheckbox(event, item.ID)}
                            name="SmsActive" />}
                          label={'Sms'}
                          disabled={!excludeIds?.includes(item.ID) ? false : true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          id='description'
                          variant='outlined'
                          fullWidth
                          label="Sms Başlık"
                          value={item.ACIKLAMA}
                          onChange={(event) => handleChangeHeader(event, item.ID)}
                          disabled={!excludeIds?.includes(item.ID) ? false : true}
                        />
                        <br />
                        <br />
                      </Grid>

                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          id='description'
                          variant='outlined'
                          fullWidth
                          multiline
                          minRows={10}
                          label="Sms Metin"
                          value={item.SMS_METIN}
                          onChange={(event) => handleChangeText(event, item.ID)}
                          disabled={!excludeIds?.includes(item.ID) ? false : true}
                        />
                      </Grid>
                    </CardContent>
                    <Divider />
                    <CardActions>
                      <Button
                        variant="contained"
                        size="small"
                        fullWidth
                        style={{ color: '#FF9800', backgroundColor: '#424242' }}
                        startIcon={<SaveIcon style={{ color: "orange" }} />}
                        onClick={(event) => addSmsEmailTemplate(event, item.ID)}
                        disabled={!excludeIds?.includes(item.ID) ? false : true}
                      >
                        Kaydet
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        fullWidth
                        style={{ color: '#FF9800', backgroundColor: '#424242' }}
                        startIcon={<InfoIcon style={{ color: "orange" }} />}
                        onClick={() => { GetBrandSessionUser(item.ID) }}
                        disabled={!excludeIds?.includes(item.ID) ? false : true}
                      >
                        Kullanıcı
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>

              ))}
          </Grid>
        </ExpansionPanelDetails >
      </ExpansionPanel >


      <Dialog
        open={durumVeUrunGruplariPopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Durum ve Ürün Grupları Güncelleme</DialogTitle>
        <DialogContent>
          <Grid container spacing={1} style={{ marginTop: '1rem', marginBottom: '1rem' }}>
            {sablonDurumBilgisiRequest?.map((row) => (
              <Grid item xs={6} sm={6} lg={6}>
                <Autocomplete
                  fullWidth
                  value={smsDurumlar.find((durum) => durum.DURUM === row.DURUM_ID) || null}
                  options={smsDurumlar}
                  getOptionLabel={(val) => val.ACIKLAMA}
                  renderInput={(params) => <TextField {...params} variant="outlined" label="Durum Seçiniz..." />}
                  onChange={(event, newValue) => handleChangeStatus(event, row.MESAJ_SABLON_ID, newValue)}
                />
              </Grid>
            ))}
            <Grid item xs={6} sm={6} lg={6} >
              <Autocomplete
                id="multiple-limit-tags"
                fullWidth
                multiple
                disableCloseOnSelect
                limitTags={1}
                value={smsModeller.filter(item => sablonUrunGrupBilgisiRequest.map(k => k.Id).includes(item.Id))}
                options={smsModeller}
                getOptionLabel={(option) => option.Dsc}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.Dsc}
                  </li>
                )}
                renderInput={(params) => <TextField {...params} variant="outlined" label="Ürün Grupları" />}
                onChange={(event, newValue) => { setSablonUrunGrupBilgisiRequest(newValue) }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="medium"
            color='primary'
            style={{ color: 'white' }}
            className={classes.button}
            onClick={() => { urunGrubuVeDurumGuncelle(); }}
          >
            Güncelle
          </Button>
          <Button
            variant="contained"
            size="medium"
            color='primary'
            style={{ color: 'white' }}
            className={classes.button}
            onClick={() => {
              setDurumVeUrunGruplariPopUp(false);
            }}
          >
            Kapat
          </Button>
        </DialogActions>

      </Dialog>

      {/* Sms Bilgi Info PopUp */}
      <Dialog
        open={smsInfoPopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.Title} >{'KULLANICI BİLGİLERİ'}</DialogTitle>
        <DialogContent>
          {brandSessionUserData.map((row) => (
            <Grid key={row.ID}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <TextField
                    value={row.MARKA}
                    id="outlined-required"
                    size="medium"
                    label="MARKA"
                    disabled
                    fullWidth
                    variant="outlined"
                    margin='normal'
                    inputProps={{
                      style: {
                        fontWeight: 'bold',
                        opacity: 1,
                        color: 'black',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    defaultValue={row.KULLANICI_ADI}
                    id="outlined-required"
                    size="medium"
                    fullWidth
                    label="ID"
                    variant="outlined"
                    margin='normal'
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}

        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={10} md={10}>
              <Button
                variant="contained"
                size="medium"
                color='primary'
                startIcon={<SaveIcon style={{ color: "white" }} />}
                style={{ color: 'white' }}
                className={classes.button}
              >
                Güncelle
              </Button>
            </Grid>
            <Grid item xs={2} md={2}>
              <IconButton
                color="primary"
                onClick={() => {
                  setSmsInfoPopUp(false)
                }}
                aria-label="close"
                component="span"
                variant="contained"
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog >

      {/* Şablon Önizleme PopUp */}
      <Dialog
        open={smsSablonOnizle}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className={classes.Title} >{'Şablon Önizleme Ekranı'}</DialogTitle>
        <DialogContent>
          {sablonOnizlemeMetin.map((row) => (
            <TextField key={row.ID}
              id="outlined-required"
              size="medium"
              label="Şablon İçerik"
              disabled
              value={row.SABLON}
              multiline
              minRows={10}
              fullWidth
              variant="outlined"
              inputProps={{
                style: {
                  fontWeight: 'bold',
                  opacity: 1,
                  color: 'black',
                }
              }}
            />
          ))}
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => {
              setSmsSablonOnizle(false)
            }}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog >

      {/* Şablon Görüntüle PopUp */}
      <Dialog
        open={smsSablonGoruntule}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className={classes.Title} >{'Şablon Detay Görüntüleme'}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} spacing={1}>
            <Grid item xs={12} sm={12} lg={12}>
              <Typography variant="h6" style={{ color: '#FF8900' }}>
                {'Fiş Durumu'}
              </Typography>
              {smsGoruntulemeData?.map((item) => (
                <Typography variant="body1" key={item.Id}>
                  {item?.ACIKLAMA}
                </Typography>
              ))}
            </Grid>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} spacing={1}>
            <Grid item xs={12} sm={12} lg={12}>
              <Typography variant="h6" style={{ color: '#FF8900' }}>
                {'Ürün Grubu'}
              </Typography>
              {smsGoruntulemeData2?.map((item2) => (
                <Typography variant="body1" key={item2.Id}>
                  {item2?.Dsc}
                </Typography>
              ))}
            </Grid>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} spacing={1}>
            <Grid item xs={12} sm={12} lg={12}>
              <Typography variant="h6" style={{ color: '#FF8900' }}>
                {'Sms Koşulları'}
              </Typography>
              {smsGoruntulemeData?.map((item3) => (
                <Typography variant="body1" key={item3.Id} style={{ wordWrap: 'break-word' }}>
                  {item3?.SABLON_KOSULLAR}
                </Typography>
              ))}
            </Grid>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} spacing={1}>
            <Grid item xs={12} sm={12} lg={12}>
              <Typography variant="h6" style={{ color: '#FF8900' }}>
                {'Sms Yeni Projeye Taşındı mı ?'}
              </Typography>
              {smsGoruntulemeData?.map((item4) => (
                <Typography variant="body1" key={item4.Id} style={{ wordWrap: 'break-word' }}>
                  {item4?.YENI_PROJEYE_TASINDI_MI === 1 ? 'Evet' : 'Hayır'}
                </Typography>
              ))}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            aria-label="close"
            component="span"
            variant="contained"
            onClick={() => {
              setSmsSablonGoruntule(false)
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog >
    </>
  );
}

export default SmsManagement;
